import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { AuthService } from '../Services/auth.service';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
    constructor(private auth: AuthService, private router: Router, private toastr: ToastrService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with basic auth credentials if available

        return this.auth.getUser2().pipe(
            switchMap((user) => {
                if(user){
                    return this.auth.getIdToken2().pipe(
                        switchMap((res) => {
                            request = request.clone({
                                setHeaders : {
                                    Authorization : `Bearer ${res}`
                                }
                            });
                            return next.handle(request);
                        }),
                        catchError((error: HttpErrorResponse) => {
                            if(error.status == 403 || error.status == 401){
                                this.auth.renewToken2().pipe(
                                    switchMap(() => {
                                        return this.auth.getIdToken2().pipe(
                                            switchMap((res) => {
                                                request = request.clone({
                                                    setHeaders : {
                                                        Authorization : `Bearer ${res}`
                                                    }
                                                });
                                                return next.handle(request);
                                            })
                                        )
                                    })
                                )
                            }else{                                
                                let arr = error.error.error.errors;
                                
                                for(let i=0; i<arr.length; i++){
                                    this.toastr.error(arr[i]);
                                }
                                
                                return throwError(error);
                            }
                        })
                    )
                }
                else{
                    return next.handle(request);
                }
            })
        )
    }
}